export enum ActivityReportEnum {
  Progress,
  Certification,
}
